import { Loader2 } from 'lucide-react'

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg'
  text?: string
}

const sizeMap = {
  sm: 'w-4 h-4',
  md: 'w-8 h-8',
  lg: 'w-12 h-12',
}

export default function LoadingSpinner({ size = 'md', text }: LoadingSpinnerProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3">
      <Loader2
        className={`${sizeMap[size]} animate-spin`}
        style={{ color: '#4F46E5' }}
      />
      {text && (
        <p className="text-sm" style={{ color: '#94A3B8' }}>{text}</p>
      )}
    </div>
  )
}
